import {useEffect} from "react"
import { useSignal } from "@preact/signals-react"
import { useTheme } from "@mui/material";
import { HeatColor } from "@ui-seeker/utils";

import { GROUPED_BY } from "@constants";
import { catalogueAnalyzerTabSelected, catalogueAnalyzerRowClick } from "../../@signals";
import { RECORD_COUNT_KPI } from "../../@constants"


export default function useCatalogueAnalyzerGroupedVsSiteTable() {
	const { palette } = useTheme()

	const toggleSelected = useSignal(RECORD_COUNT_KPI.AVG_PRICE)
	
	const handleChangeToogle = (_, newValue) => {
		toggleSelected.value = newValue
	}

	const handleClickRow = (rowIndex) => {
		if (rowIndex === catalogueAnalyzerRowClick.value)
			catalogueAnalyzerRowClick.value = null
		else
		catalogueAnalyzerRowClick.value = rowIndex
	}

	const generateHeatColorInstance = (heatColorRanges) => {
		if (toggleSelected.value === RECORD_COUNT_KPI.AVG_PRICE ) {
			return new HeatColor({
				min: heatColorRanges.min_avg_price,
				max: heatColorRanges.max_avg_price,
				color: palette.primary.light
			})
		}

		if (toggleSelected.value === RECORD_COUNT_KPI.MAX_PRICE ) {
			return new HeatColor({
				min: heatColorRanges.min_max_price,
				max: heatColorRanges.max_max_price,
				color: palette.primary.light
			})
		}

		if (toggleSelected.value === RECORD_COUNT_KPI.MIN_PRICE ) {
			return new HeatColor({
				min: heatColorRanges.min_min_price,
				max: heatColorRanges.max_min_price,
				color: palette.primary.light
			})
		}

		if (toggleSelected.value === RECORD_COUNT_KPI.PRODUCTS ) {
			return new HeatColor({
				min: heatColorRanges.min_products,
				max: heatColorRanges.max_products,
				color: palette.primary.light
			})
		}
	}

	return {
		toggleSelected: toggleSelected.value,
		groupedLabel: catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND ? 'Brand' : 'Category',
		handleChangeToogle,
		handleClickRow,
		generateHeatColorInstance,
		title: (catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND ? 'Brand' : 'Category') + ' Overview by Site',
		isPriceSelected: toggleSelected.value !== RECORD_COUNT_KPI.PRODUCTS
	}
}